import { create } from 'zustand';

interface ModalEntry {
  id: string;
  onClose: () => void;
}

interface ModalStack {
  stack: ModalEntry[];
  push: (entry: ModalEntry) => void;
  pop: (id: string) => void;
  /** Closes the top-most modal. Returns true if a modal was closed. */
  closeTop: () => boolean;
}

export const useModalStack = create<ModalStack>((set, get) => ({
  stack: [],
  push: (entry) =>
    set((s) => (s.stack.some((e) => e.id === entry.id) ? s : { stack: [...s.stack, entry] })),
  pop: (id) => set((s) => ({ stack: s.stack.filter((e) => e.id !== id) })),
  closeTop: () => {
    const stack = get().stack;
    const top = stack[stack.length - 1];
    if (top) {
      top.onClose();
      return true;
    }
    return false;
  },
}));
